import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"
import { Link } from "react-router-dom"

const CTA = () => {

    const [ref, inView] = useInView({ triggerOnce: true })

    return (
        <div className="flex flex-col space-y-6 lg:flex-row mx-auto p-6 lg:px-12 lg:py-20 mt-12 bg-white dark:bg-[#202222] text-zinc-900 dark:text-zinc-100 justify-between items-start lg:items-center border-t border-b border-slate-200 dark:border-slate-800/80 transition-colors duration-300 w-full">
            <div className="space-y-4">
                <motion.h2 className="text-4xl lg:text-5xl font-light text-zinc-900 dark:text-white" ref={ref} initial={{ y: -10, opacity: 0 }} animate={inView? { y: 0, opacity: 1, delay: 0.5 }: {}} exit={{ y: -10, opacity: 0 }} transition={{ duration: 0.5 }}>Let us be your partner in <span className="text-purple-600 dark:text-purple-400 font-semibold">growth.</span> </motion.h2>
                <motion.p className="text-sm text-zinc-500 dark:text-zinc-400" ref={ref} initial={{ y: 10, opacity: 0 }} animate={inView? { y: 0, opacity: 1, delay: 0.5 }: {}} exit={{ y: 10, opacity: 0 }} transition={{ duration: 0.5, delay: 0.5 }}>Partner with Jibu Labs and leverage our elite AI consulting and engineering expertise to scale your business.</motion.p>
            </div>
            <div>
                <motion.button 
                    onClick={() => {
                        window.dispatchEvent(new CustomEvent("open-questionnaire", { detail: { plan: "General Consulting" } }));
                    }}
                    className="bg-zinc-950 text-white dark:bg-white dark:text-zinc-950 p-3 lg:py-4 lg:px-6 rounded-full text-sm space-x-1 font-semibold hover:bg-zinc-800 dark:hover:bg-zinc-100 transition-colors duration-200 shadow-sm cursor-pointer" 
                    ref={ref} 
                    layout 
                    initial={{ opacity: 0 }} 
                    animate={inView? { opacity: 1 }: {}} 
                    exit={{ opacity: 0 }} 
                    transition={{ duration: 0.5, delay: 1 }}
                >
                    <span className="inline-block">Contact Sales</span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 inline-block">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                    </svg>
                </motion.button>
            </div>
            
        </div>
    )
}

export default CTA